import React, { ElementType, useEffect } from "react";
import {
	CommonPropertyProps,
	ElementSchema,
	ElementTypeList,
	ValidationRules,
	Validation,
} from "schemas/elements";
import elementsSchema from "schemas";
import { ValidationMap } from "../properties";
import { v4 as uuidv4 } from "uuid";
import { Elem, ElemBefore } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";

type validationProps = "maxLength" | "minLength" | "format" | "allowNull";

type validationPropertyTypes = "number" | "regex" | "boolean"; // Boolean props are missing `nextProp` so only works with allowNull

type Props = Omit<CommonPropertyProps, "value"> & {
	elem: string;
	value: Validation;
	tableNested?: boolean;
};

export default ({
	updateStore,
	field,
	required,
	value,
	desc,
	validation,
	elementIndex,
	elem,
	tableNested,
}: Props) => {
	const { t } = useTranslation();
	const props = {
		updateStore,
		field,
		required,
		elementIndex,
		validation,
		value: { ...value },
	};
	const myElementSchema: ElementSchema = elementsSchema as ElementSchema;
	// looks for the element in the schema to get the props it needs for later
	const validationElement: ValidationRules =
		myElementSchema[elem as ElementTypeList].validation.rules;

	useEffect(() => {
		if (tableNested && value === undefined) {
			updateStore({
				elementIndex,
				property: field,
				value: { allowNull: true },
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (elem === "reference") return <></>;
	else
		return (
			<Elem className="elem-validation">
				<ElemBefore
					label={t(`formDesigner.properties.${field}`)}
					required={required}
				/>
				<div className="hint-text">
					{t(`formDesigner.elements.${desc}`)}
				</div>
				<div className="elem-validation-properties">
					{Object.keys(validationElement).map(property => {
						const theProperty = property as validationProps;
						const theObject = validationElement[theProperty];
						const Property: ElementType =
							ValidationMap[
								theObject.type as validationPropertyTypes
							];
						const id: string = uuidv4();
						return (
							<Property
								key={theProperty}
								{...props}
								id={id}
								nextProp={property}
								desc={theObject?.desc}
								required={theObject?.required}
							/>
						);
					})}
				</div>
			</Elem>
		);
};
